export default "__VITE_ASSET__BUuj$Qc7__"